/**
 * Copyright (c) 2017 CA. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

// @flow

import * as env from './env';

export default {
  portal: {
    use_papi: env.PORTAL_USE_PAPI,
    use_session: env.PORTAL_USE_SESSION,
    hostname: window.location.hostname === 'localhost' ? 'https://apim.dev.ca.com' : `https://${window.location.hostname}`,
    tenantPrefix: env.PORTAL_TENANT_ID || window.tenant,
    detect_tenant_id: env.PORTAL_DETECT_TENANT_ID,
  },
  server: {
    hostname: env.SERVER_HOSTNAME,
    port: env.SERVER_PORT,
    prefix: '',
    server_certs: [],
  },
  oauth: {
    client: {
      organization: 'CA Technologies',
      description: 'Phoenix Client',
      client_name: 'Phoenix Client',
      client_type: 'public',
      registered_by: 'admin',
      client_custom: {},
      client_ids: [

        {
          client_id: env.CLIENT_ID,
          client_secret: '',
          scope: env.CLIENT_SCOPE,
          redirect_uri: env.CLIENT_REDIRECT_URI,
          environment: 'ALL',
          status: 'ENABLED',
          registered_by: 'admin',
          service_ids: '',
          account_plan_mapping_ids: '',
          client_key_custom: {},
        },
      ],
    },
    system_endpoints: {
      authorization_endpoint_path: '/auth/oauth/v2/authorize',
      token_endpoint_path: '/auth/oauth/v2/token',
      token_revocation_endpoint_path: '/auth/oauth/v2/token/revoke',
      usersession_logout_endpoint_path: '/connect/session/logout',
      usersession_status_endpoint_path: '/connect/session/status',
    },
    oauth_protected_endpoints: {
      userinfo_endpoint_path: '/openid/connect/v1/userinfo',
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/defaultConfig.js